// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Страница переписки по ссылке из MAX: под телефон, на всю высоту. */
.ol-page {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
  background: #fff;
  color: var(--v2-primary);
  font-family: inherit;
}
.ol-center {
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  text-align: center;
}
.ol-logo {
  font-weight: 800;
  letter-spacing: 0.08em;
}
.ol-muted {
  color: var(--v2-muted);
}
.ol-head {
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--v2-border-soft);
}
.ol-who {
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-right: auto;
}
.ol-who b {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ol-who span {
  font-size: 12px;
  color: var(--v2-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ol-scroll {
  padding: 14px 14px 8px;
}
.ol-input-zone {
  padding: 8px 10px calc(10px + env(safe-area-inset-bottom));
}
.ol-err {
  margin: 0 14px 6px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #fef2f2;
  color: #991b1b;
  font-size: 13px;
}
.ol-page .op-msg.is-user,
.ol-page .op-msg.is-operator {
  max-width: 88%;
}
.ol-page .op-photo img {
  max-width: 220px;
}
/* «Принять» внизу, под большим пальцем (решение 30.10). */
.ol-accept-zone {
  flex: none;
  padding: 10px 14px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--v2-bg);
}
.ol-accept {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 12px;
  background: var(--v2-primary);
  color: #fff;
  font: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.ol-accept:disabled {
  opacity: 0.6;
}

/* iPhone не увеличивает страницу, если шрифт поля ввода не меньше 16px. */
.ol-page textarea,
.ol-page input {
  font-size: 16px !important;
}
.ol-page .tc-input-wrap {
  max-width: none;
}
.ol-back {
  flex: none;
  width: 34px;
  height: 34px;
  margin-left: -6px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--v2-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ol-ava {
  flex: none;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}
.ol-who span {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Плашка канала: откуда пришёл клиент. */
.ol-chip {
  flex: none;
  display: inline-flex;
  align-items: center;
  height: 17px;
  padding: 0 6px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  background: var(--v2-hover);
  color: var(--v2-muted);
}
.ol-chip.is-max {
  background: #ede9fe;
  color: #6d28d9;
}
.ol-chip.is-telegram {
  background: #e0f2fe;
  color: #0369a1;
}

/* Список разговоров — как чаты в Telegram. */
.ol-list-head {
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}
.ol-list-head b {
  font-size: 18px;
}
.ol-list-head span {
  font-size: 12px;
  color: var(--v2-muted);
}
.ol-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.ol-empty {
  padding: 40px 20px;
  text-align: center;
}
.ol-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 9px 14px;
  border: 0;
  background: #fff;
  text-align: left;
  font: inherit;
  cursor: pointer;
}
.ol-row:active {
  background: var(--v2-bg);
}
.ol-row.is-closed {
  opacity: 0.55;
}
.ol-row-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-bottom: 9px;
  margin-bottom: -9px;
  border-bottom: 1px solid var(--v2-bg);
}
.ol-row-top,
.ol-row-bottom {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.ol-row-top b {
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ol-row-time {
  margin-left: auto;
  flex: none;
  font-size: 12px;
  color: var(--v2-muted);
}
.ol-row-text {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: var(--v2-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ol-unread {
  flex: none;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  background: #dc2626;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
}
/* Буквенная аватарка — круглая и крупнее буква, как в Telegram. */
.ol-page .v2-avatar {
  border-radius: 50% !important;
  font-size: 18px !important;
  font-weight: 600;
  flex: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/operator-link/operator-link.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA,0DAA0D;AAC1D;EACE,UAAU;EACV,2DAA2D;EAC3D,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA,0EAA0E;AAC1E;;EAEE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;AACR;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,kEAAkE;AAClE;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":["/* Страница переписки по ссылке из MAX: под телефон, на всю высоту. */\n.ol-page {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  overflow: hidden;\n  background: #fff;\n  color: var(--v2-primary);\n  font-family: inherit;\n}\n.ol-center {\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 24px;\n  text-align: center;\n}\n.ol-logo {\n  font-weight: 800;\n  letter-spacing: 0.08em;\n}\n.ol-muted {\n  color: var(--v2-muted);\n}\n.ol-head {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.ol-who {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  margin-right: auto;\n}\n.ol-who b {\n  font-size: 15px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ol-who span {\n  font-size: 12px;\n  color: var(--v2-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ol-scroll {\n  padding: 14px 14px 8px;\n}\n.ol-input-zone {\n  padding: 8px 10px calc(10px + env(safe-area-inset-bottom));\n}\n.ol-err {\n  margin: 0 14px 6px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: #fef2f2;\n  color: #991b1b;\n  font-size: 13px;\n}\n.ol-page .op-msg.is-user,\n.ol-page .op-msg.is-operator {\n  max-width: 88%;\n}\n.ol-page .op-photo img {\n  max-width: 220px;\n}\n/* «Принять» внизу, под большим пальцем (решение 30.10). */\n.ol-accept-zone {\n  flex: none;\n  padding: 10px 14px calc(12px + env(safe-area-inset-bottom));\n  border-top: 1px solid var(--v2-bg);\n}\n.ol-accept {\n  width: 100%;\n  height: 48px;\n  border: 0;\n  border-radius: 12px;\n  background: var(--v2-primary);\n  color: #fff;\n  font: inherit;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.ol-accept:disabled {\n  opacity: 0.6;\n}\n\n/* iPhone не увеличивает страницу, если шрифт поля ввода не меньше 16px. */\n.ol-page textarea,\n.ol-page input {\n  font-size: 16px !important;\n}\n.ol-page .tc-input-wrap {\n  max-width: none;\n}\n.ol-back {\n  flex: none;\n  width: 34px;\n  height: 34px;\n  margin-left: -6px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--v2-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.ol-ava {\n  flex: none;\n  border-radius: 50%;\n  object-fit: cover;\n  display: block;\n}\n.ol-who span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Плашка канала: откуда пришёл клиент. */\n.ol-chip {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  height: 17px;\n  padding: 0 6px;\n  border-radius: 5px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  background: var(--v2-hover);\n  color: var(--v2-muted);\n}\n.ol-chip.is-max {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n.ol-chip.is-telegram {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n/* Список разговоров — как чаты в Telegram. */\n.ol-list-head {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n}\n.ol-list-head b {\n  font-size: 18px;\n}\n.ol-list-head span {\n  font-size: 12px;\n  color: var(--v2-muted);\n}\n.ol-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.ol-empty {\n  padding: 40px 20px;\n  text-align: center;\n}\n.ol-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 9px 14px;\n  border: 0;\n  background: #fff;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n}\n.ol-row:active {\n  background: var(--v2-bg);\n}\n.ol-row.is-closed {\n  opacity: 0.55;\n}\n.ol-row-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding-bottom: 9px;\n  margin-bottom: -9px;\n  border-bottom: 1px solid var(--v2-bg);\n}\n.ol-row-top,\n.ol-row-bottom {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n.ol-row-top b {\n  font-size: 16px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ol-row-time {\n  margin-left: auto;\n  flex: none;\n  font-size: 12px;\n  color: var(--v2-muted);\n}\n.ol-row-text {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  color: var(--v2-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ol-unread {\n  flex: none;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 7px;\n  border-radius: 11px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 22px;\n  text-align: center;\n}\n/* Буквенная аватарка — круглая и крупнее буква, как в Telegram. */\n.ol-page .v2-avatar {\n  border-radius: 50% !important;\n  font-size: 18px !important;\n  font-weight: 600;\n  flex: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
